import React from 'react';
import wb0 from '../img/Detail/awaken_detail.jpg';
import './Detail.css';
const AwakenDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default AwakenDetail;